import { httpClient } from "../http/httpClient";

export interface HandleSupportParams {
  id: string;
  data: {
    link?: string;
    observation?: string;
    canUploadDocs?: boolean;
    isStatusLocked?: boolean;
  };
}

export const handleSupport = async ({ id, data }: HandleSupportParams) => {
  const response = await httpClient
    .patch(`/transaction/${id}/support`, data)
    .catch((err) => {
      throw err?.response?.data || err;
    });
  return response.data;
};
